<template>
  <div>
    <label :for='labelId' class='block text-sm font-medium leading-6 text-gray-900 sr-only'>{{ props.label || 'Search' }}</label>
    <div class='relative rounded-md shadow-sm'>
      <div class='pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3'>
        <MagnifyingGlassIcon class='h-5 w-5 text-gray-400' aria-hidden='true' />
      </div>
      <input :id='labelId' type='text' name='search' id='search' class='block w-full rounded-md border-0 py-1.5 pl-10 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-jananavy-600 sm:text-sm sm:leading-6' placeholder='Search' v-model='model' :class='{"pr-10": props.isLoading}' />
      <div class='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3' v-if='props.isLoading'>
        <LoadingIcon class='h-5 w-5' aria-hidden='true' />
      </div>
    </div>
  </div>
</template>

<script setup>

import { nanoid } from 'nanoid';

import { MagnifyingGlassIcon } from '@heroicons/vue/20/solid';

import LoadingIcon from '@/components/icons/loading-icon.vue';

const model = defineModel();

const labelId = nanoid();

const props = defineProps({
  label: String,
  isLoading: Boolean
});

</script>